import { GameFreeSpinsOverlayProperties } from "@lib/js-slingo-pawnshop-core/dist";
/**
 * FreeSpinsOverlayPortraitProperties.ts
 */
export class FreeSpinsOverlayPortraitProperties extends GameFreeSpinsOverlayProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
